/* eslint-disable react/prop-types */

import { Box, Card, Grid, Stack, Typography } from "@mui/material";
import LocationOnRoundedIcon from "@mui/icons-material/LocationOnRounded";
import RadarRoundedIcon from "@mui/icons-material/RadarRounded";
import CalendarMonthRoundedIcon from "@mui/icons-material/CalendarMonthRounded";
import NearMeRoundedIcon from "@mui/icons-material/NearMeRounded";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import { panelCardSx } from ".";
import { alpha } from "@mui/material/styles";
import InfoChip from "./InfoChip";

export default function SelectedBusinessCard({ business, getLat, getLong, searchInfo }) {
    return (
        <Card
            sx={{
                ...panelCardSx,
                p: { xs: 2.3, md: 3 },
                mb: 3,
                borderColor: alpha("#16a34a", 0.22),
                bgcolor: alpha("#16a34a", 0.025),
            }}
        >
            <Grid container spacing={2} alignItems="center">
                <Grid item xs={12} md={4}>
                    <Stack direction="row" spacing={1.3} alignItems="center">
                        <Box
                            sx={{
                                width: 46,
                                height: 46,
                                borderRadius: 2.7,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                bgcolor: alpha("#16a34a", 0.12),
                                color: "#15803d",
                            }}
                        >
                            <CheckCircleRoundedIcon />
                        </Box>

                        <Box>
                            <Typography variant="body2" sx={{ color: "#64748b", fontWeight: 700 }}>
                                بیزینس انتخاب‌شده
                            </Typography>

                            <Typography variant="h6" fontWeight={950} sx={{ color: "#0f172a" }}>
                                {business.name}
                            </Typography>
                        </Box>
                    </Stack>
                </Grid>

                <Grid item xs={12} md={8}>
                    <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
                        <InfoChip icon={<LocationOnRoundedIcon />} label={`Lat: ${getLat(business)}`} />
                        <InfoChip icon={<NearMeRoundedIcon />} label={`Long: ${getLong(business)}`} />
                        <InfoChip
                            icon={<RadarRoundedIcon />}
                            label={`شعاع: ${searchInfo.radius || "پیش‌فرض سیستم"} کیلومتر`}
                        />

                        {searchInfo.from_date && (
                            <InfoChip icon={<CalendarMonthRoundedIcon />} label={`از تاریخ: ${searchInfo.from_date}`} />
                        )}

                        {searchInfo.to_date && (
                            <InfoChip icon={<CalendarMonthRoundedIcon />} label={`تا تاریخ: ${searchInfo.to_date}`} />
                        )}
                    </Stack>
                </Grid>
            </Grid>
        </Card>
    );
}